import AOS from 'aos';
import { useEffect, useState } from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import './App.css';
import 'aos/dist/aos.css';
import { Container } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Page Components/Shared/Header/Header';
import Contact from './Page Components/Contact/Contact';
import Home from './Page Components/Home/Home';
import Blogs from './Page Components/My-Blogs/Blogs';
import Projects from './Page Components/Project/Projects';
import AboutMe from './Page Components/About/About_me';
import FrogGif from '../src/Attachments/2c80d2ced9451189047bc6f0c8a54852.gif'

function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3200);
  }, []);

  // const fetchData = () => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 8000)
  // }

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div className="App">
        {loading ? '' : <BrowserRouter>
          {/* <button onClick={fetchData}>s</button> */}
          <Header></Header>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/about-me" element={<AboutMe />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route
              path="*"
              element={
                <main style={{ padding: "1rem" }}>
                  <p>There's nothing here!</p>
                </main>
              }
            />
          </Routes>
        </BrowserRouter>}
        {loading ? <Container style={{ paddingTop: '10%', display: 'flex', justifyContent: 'center' }}><img style={{ margin: '2%', width: '50%' }} src={FrogGif} alt="" /></Container> : ''}
      </div>
      {/* <div className="Footer">
        <Footer></Footer>
      </div> */}
    </>
  );
}

export default App;